<layout-default>
    <div header>
        <div toolbar>
            <h4 *ngIf="mode != 'CREATE'" class="text-left mg-b-0 tx-spacing--1"><i-feather name="edit-3"></i-feather>
                {{'Edit users role' | translate}}</h4>
            <h4 *ngIf="mode == 'CREATE'" class="text-left mg-b-0 tx-spacing--1"><i-feather
                    name="plus-square"></i-feather> {{'Add new role' | translate}}</h4>
        </div>
        <div toolbar>
            <button class="btn btn-sm pd-x-15 btn-uppercase mg-l-5 btn-white" [routerLink]="['/users/roles']">{{'Cancel'
                | translate}}
            </button>
        </div>
        <hr />
    </div>
    <div content>
        <div class="content bg-white">

            <div class="card-content col-8 offset-2">

                <form [formGroup]="form" (ngSubmit)="onSubmit()">

                    <div id="role-from-name" class="form-group row">
                        <label class="col-2" for="name">{{'Role name' | translate}}:</label>
                        <div class="col-10">
                            <input formControlName="name" class="form-control" />
                            <div *ngIf="form.get('name').hasError('required') && form.get('name').touched"
                                class="error-color">
                                {{ "Role name is required" | translate }}!
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-2" for="permissions">{{'Roles' | translate}}:</label>
                        <div class="col-10 d-flex flex-wrap">
                            <ng-container formArrayName="permissions">
                                <ng-container *ngFor="let p of permissionsCtrl.controls; let i=index">

                                    <div id="role-from-permissions-{{i}}" formGroupName="{{i}}"
                                        class="custom-control custom-checkbox pd-b-10 w-50">
                                        <input formControlName="enabled" [checked]="p.value.enabled" type="checkbox"
                                            class="custom-control-input" id="customCheck{{i}}">
                                        <label class="custom-control-label justify-content-start"
                                            for="customCheck{{i}}">{{'Role_permissions.'+p.value.name |
                                            translate}}</label>
                                    </div>

                                </ng-container>
                            </ng-container>
                        </div>
                    </div>

                    <div id="role-from-btn-submit" class="form-group row justify-content-end">
                        <div class="col-2">
                            <button [disabled]="!form.valid || submitted"
                                class="btn btn-sm pd-x-15 btn-uppercase mg-l-5 btn-brand-01 w-100">

                                <span *ngIf="!submitted">{{ "Save" | translate }}</span>

                                <ng-container *ngIf="submitted">
                                    <div class="load-spinner text-center">
                                        <i class="fa fa-spinner fast-pulse" aria-hidden="true"></i>
                                    </div>
                                </ng-container>

                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</layout-default>